<template>
	<vue-scroll class="page-element-form">
		<div class="page-header">
			<h1>Element Form
				<theme-picker style="float:right"></theme-picker>
			</h1>
			<h4><a href="http://element.eleme.io/#/en-US/component/form" target="_blank"><i class="mdi mdi-book-open-page-variant"></i> see from the complete documentation</a></h4>
		</div>
		<div class="card-base card-shadow--medium demo-box bg-white hidden-xs-only">
			<el-collapse value="1">
				<el-collapse-item title="Basic form" name="1">
					<el-form ref="form" :model="form" label-width="120px">
						<el-form-item label="Activity name">
							<el-input v-model="form.name"></el-input>
						</el-form-item>
						<el-form-item label="Activity zone">
							<el-select v-model="form.region" placeholder="please select your zone">
							<el-option label="Zone one" value="shanghai"></el-option>
							<el-option label="Zone two" value="beijing"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="Activity time">
							<el-col :span="11">
							<el-date-picker type="date" placeholder="Pick a date" v-model="form.date1" style="width: 100%;"></el-date-picker>
							</el-col>
							<el-col class="line" :span="2">&nbsp;</el-col>
							<el-col :span="11">
							<el-time-picker type="fixed-time" placeholder="Pick a time" v-model="form.date2" style="width: 100%;"></el-time-picker>
							</el-col>
						</el-form-item>
						<el-form-item label="Instant delivery">
							<el-switch v-model="form.delivery"></el-switch>
						</el-form-item>
						<el-form-item label="Activity type">
							<el-checkbox-group v-model="form.type">
							<el-checkbox label="Online activities" name="type"></el-checkbox>
							<el-checkbox label="Promotion activities" name="type"></el-checkbox>
							<el-checkbox label="Offline activities" name="type"></el-checkbox>
							<el-checkbox label="Simple brand exposure" name="type"></el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<el-form-item label="Resources">
							<el-radio-group v-model="form.resource">
							<el-radio label="Sponsor"></el-radio>
							<el-radio label="Venue"></el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="Activity form">
							<el-input type="textarea" v-model="form.desc"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="onSubmit">Create</el-button>
							<el-button>Cancel</el-button>
						</el-form-item>
						</el-form>
				</el-collapse-item>
				<el-collapse-item title="Code" name="2">
					<pre v-highlightjs="code1"><code class="html"></code></pre>
				</el-collapse-item>
			</el-collapse>
		</div>
		<div class="card-base card-shadow--medium demo-box bg-white">
			<el-collapse value="1">
				<el-collapse-item title="Inline form" name="1">
					<el-form :inline="true" :model="formInline" class="demo-form-inline">
						<el-form-item label="Approved by">
							<el-input v-model="formInline.user" placeholder="Approved by"></el-input>
						</el-form-item>
						<el-form-item label="Activity zone">
							<el-select v-model="formInline.region" placeholder="Activity zone">
							<el-option label="Zone one" value="shanghai"></el-option>
							<el-option label="Zone two" value="beijing"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="onSubmit">Query</el-button>
						</el-form-item>
					</el-form>
				</el-collapse-item>
				<el-collapse-item title="Code" name="2">
					<pre v-highlightjs="code2"><code class="html"></code></pre>
				</el-collapse-item>
			</el-collapse>
		</div>
		<div class="card-base card-shadow--medium demo-box bg-white">
			<el-collapse value="1">
				<el-collapse-item title="Alignment" name="1">
					<el-radio-group v-model="labelPosition" size="small">
					<el-radio-button label="left">Left</el-radio-button>
					<el-radio-button label="right">Right</el-radio-button>
					<el-radio-button label="top">Top</el-radio-button>
					</el-radio-group>
					<div style="margin: 20px;"></div>
					<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign">
					<el-form-item label="Name">
						<el-input v-model="formLabelAlign.name"></el-input>
					</el-form-item>
					<el-form-item label="Activity zone">
						<el-input v-model="formLabelAlign.region"></el-input>
					</el-form-item>
					<el-form-item label="Activity form">
						<el-input v-model="formLabelAlign.type"></el-input>
					</el-form-item>
					</el-form>
				</el-collapse-item>
				<el-collapse-item title="Code" name="2">
					<pre v-highlightjs="code3"><code class="html"></code></pre>
				</el-collapse-item>
			</el-collapse>
		</div>
		<div class="card-base card-shadow--medium demo-box bg-white">
			<el-collapse value="1">
				<el-collapse-item title="Custom validation rules" name="1">
					<el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="120px" class="demo-ruleForm">
					<el-form-item label="Password" prop="pass">
						<el-input type="password" v-model="ruleForm2.pass" auto-complete="off"></el-input>
					</el-form-item>
					<el-form-item label="Confirm" prop="checkPass">
						<el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
					</el-form-item>
					<el-form-item label="Age" prop="age">
						<el-input v-model.number="ruleForm2.age"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitForm('ruleForm2')">Submit</el-button>
						<el-button @click="resetForm('ruleForm2')">Reset</el-button>
					</el-form-item>
					</el-form>
				</el-collapse-item>
				<el-collapse-item title="Code" name="2">
					<pre v-highlightjs="code4"><code class="html"></code></pre>
				</el-collapse-item>
			</el-collapse>
		</div>
	</vue-scroll>
</template>

<script>
import ThemePicker from '@/components/theme-picker'

export default {
	name: 'ElementForm',
	data() {
		var checkAge = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('Please input the age'));
        }
        setTimeout(() => {
			if (!Number.isInteger(value)) {
				callback(new Error('Please input digits'));
			} else {
				if (value < 18) {
				callback(new Error('Age must be greater than 18'));
				} else {
				callback();
				}
			}
			}, 1000);
		};
		var validatePass = (rule, value, callback) => {
			if (value === '') {
			callback(new Error('Please input the password'));
			} else {
			if (this.ruleForm2.checkPass !== '') {
				this.$refs.ruleForm2.validateField('checkPass');
			}
			callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
			callback(new Error('Please input the password again'));
			} else if (value !== this.ruleForm2.pass) {
			callback(new Error('Two inputs don\'t match!'));
			} else {
			callback();
			}
		};
		return {
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			},
			formInline: {
			user: '',
			region: ''
			},
			labelPosition: 'right',
			formLabelAlign: {
			name: '',
			region: '',
			type: ''
			},
			ruleForm2: {
			pass: '',
			checkPass: '',
			age: ''
			},
			rules2: {
			pass: [
				{ validator: validatePass, trigger: 'blur' }
			],
			checkPass: [
				{ validator: validatePass2, trigger: 'blur' }
			],
			age: [
				{ validator: checkAge, trigger: 'blur' }
			]
			},
			code1: 
`
<el-form ref="form" :model="form" label-width="120px">
  <el-form-item label="Activity name">
    <el-input v-model="form.name"></el-input>
  </el-form-item>
  <el-form-item label="Activity zone">
    <el-select v-model="form.region" placeholder="please select your zone">
      <el-option label="Zone one" value="shanghai"></el-option>
      <el-option label="Zone two" value="beijing"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="Activity time">
    <el-col :span="11">
      <el-date-picker type="date" placeholder="Pick a date" v-model="form.date1" style="width: 100%;"></el-date-picker>
    </el-col>
    <el-col class="line" :span="2">-</el-col>
    <el-col :span="11">
      <el-time-picker type="fixed-time" placeholder="Pick a time" v-model="form.date2" style="width: 100%;"></el-time-picker>
    </el-col>
  </el-form-item>
  <el-form-item label="Instant delivery">
    <el-switch v-model="form.delivery"></el-switch>
  </el-form-item>
  <el-form-item label="Activity type">
    <el-checkbox-group v-model="form.type">
      <el-checkbox label="Online activities" name="type"></el-checkbox>
      <el-checkbox label="Promotion activities" name="type"></el-checkbox>
      <el-checkbox label="Offline activities" name="type"></el-checkbox>
      <el-checkbox label="Simple brand exposure" name="type"></el-checkbox>
    </el-checkbox-group>
  </el-form-item>
  <el-form-item label="Resources">
    <el-radio-group v-model="form.resource">
      <el-radio label="Sponsor"></el-radio>
      <el-radio label="Venue"></el-radio>
    </el-radio-group>
  </el-form-item>
  <el-form-item label="Activity form">
    <el-input type="textarea" v-model="form.desc"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="onSubmit">Create</el-button>
    <el-button>Cancel</el-button>
  </el-form-item>
</el-form>
<script>
  export default {
    data() {
      return {
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        }
      }
    },
    methods: {
      onSubmit() {
        console.log('submit!');
      }
    }
  }
<\/script>`
		,code2:
`
<el-form :inline="true" :model="formInline" class="demo-form-inline">
  <el-form-item label="Approved by">
    <el-input v-model="formInline.user" placeholder="Approved by"></el-input>
  </el-form-item>
  <el-form-item label="Activity zone">
    <el-select v-model="formInline.region" placeholder="Activity zone">
      <el-option label="Zone one" value="shanghai"></el-option>
      <el-option label="Zone two" value="beijing"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="onSubmit">Query</el-button>
  </el-form-item>
</el-form>
<script>
  export default {
    data() {
      return {
        formInline: {
          user: '',
          region: ''
        }
      }
    },
    methods: {
      onSubmit() {
        console.log('submit!');
      }
    }
  }
<\/script>
`
		,code3:
`
<el-radio-group v-model="labelPosition" size="small">
  <el-radio-button label="left">Left</el-radio-button>
  <el-radio-button label="right">Right</el-radio-button>
  <el-radio-button label="top">Top</el-radio-button>
</el-radio-group>
<div style="margin: 20px;"></div>
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign">
  <el-form-item label="Name">
    <el-input v-model="formLabelAlign.name"></el-input>
  </el-form-item>
  <el-form-item label="Activity zone">
    <el-input v-model="formLabelAlign.region"></el-input>
  </el-form-item>
  <el-form-item label="Activity form">
    <el-input v-model="formLabelAlign.type"></el-input>
  </el-form-item>
</el-form>
<script>
  export default {
    data() {
      return {
        labelPosition: 'right',
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        }
      };
    }
  }
<\/script>
`
		,code4:
`
<el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="120px" class="demo-ruleForm">
  <el-form-item label="Password" prop="pass">
    <el-input type="password" v-model="ruleForm2.pass" auto-complete="off"></el-input>
  </el-form-item>
  <el-form-item label="Confirm" prop="checkPass">
    <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
  </el-form-item>
  <el-form-item label="Age" prop="age">
    <el-input v-model.number="ruleForm2.age"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="submitForm('ruleForm2')">Submit</el-button>
    <el-button @click="resetForm('ruleForm2')">Reset</el-button>
  </el-form-item>
</el-form>
<script>
  export default {
    data() {
      var checkAge = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('Please input the age'));
        }
        setTimeout(() => {
          if (!Number.isInteger(value)) {
            callback(new Error('Please input digits'));
          } else {
            if (value < 18) {
              callback(new Error('Age must be greater than 18'));
            } else {
              callback();
            }
          }
        }, 1000);
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input the password'));
        } else {
          if (this.ruleForm2.checkPass !== '') {
            this.$refs.ruleForm2.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input the password again'));
        } else if (value !== this.ruleForm2.pass) {
          callback(new Error('Two inputs don\'t match!'));
        } else {
          callback();
        }
      };
      return {
        ruleForm2: {
          pass: '',
          checkPass: '',
          age: ''
        },
        rules2: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          age: [
            { validator: checkAge, trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
<\/script>
`
		}
	},
	methods: {
      onSubmit() {
        console.log('submit!');
	  },
	  submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    },
	components: {
		ThemePicker
	}
}
</script>

<style lang="scss" scoped>
.demo-box {
	padding: 20px;
	margin-bottom: 20px;
}
pre {
	margin: 0;
	background: white;
}
code {
	padding: 0;
}

@media (max-width: 768px) {code{font-size: 70%;}}

</style>

